<template>
  <card
    :headerClasses="headerColor"
    class="no-border-card"
    body-classes="px-0 pb-1"
    footer-classes="pb-2"
  >
    <b-row class="mt-0" align-v="center" slot="header">
      <h3 class="mb-0 mt-0 text-white">{{ title }}</h3>
    </b-row>
    <el-table
      show-summary
      :summary-method="getSummaries"
      :data="tableData"
      height="360"
      style="width: 100%"
      :cell-style="{ padding: '8px' }"
    >
      <el-table-column
        v-for="column in tableColumns"
        :key="column.label"
        v-bind="column"
      >
      </el-table-column>
    </el-table>
  </card>
  <!-- </div>
    </b-container>
  </div> -->
</template>
<script>
//JSON.parse(localStorage.getItem('cakeuserdata')) pegar os dados
import { Table, TableColumn, Select, Option, Form, FormItem } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { forEach } from "jszip";
import { values } from "d3";
export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  props: {
    title: {
      type: String
    },
    headerColor: {
      type: String
    },
    data: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      expandRowKeys: [],
      sumsTotalRows: 0,
      tableColumns: [
        {
          prop: "paymentMethod",
          label: "Forma",
          formatter: (row, col, cell, index) =>
            this.formatterPaymentMethod(row),
          sortable: true
        },
        {
          prop: "total",
          label: "Valor",
          formatter: (row, col, cell, index) => this.formatterMoeda(row),
          sortable: true
        },
        {
          prop: "percent",
          label: "%",
          formatter: (row, col, cell, index) => this.percenterFromTotal(row),
          sortable: true
        }
      ],
      tableData: this.data,
      selectedRows: []
    };
  },
  watch: {
    data(newValue, oldValue) {
      this.tableData = newValue;
    }
  },
  mounted() {
    this.createFuseSearch(["name", "position", "date"]);
  },
  methods: {
    percenterFromTotal(row) {
      if (this.sumsTotalRows > 0) {
        let percent = (row.value / this.sumsTotalRows) * 100;
        return percent.toFixed(2) + "%";
      }
      return 0;
    },
    formatterMoeda(row) {
      let valorFormatado = row.value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
      return valorFormatado;
    },
    formatterPaymentMethod(row) {
      let paymentMethodTemp = JSON.parse(localStorage.getItem("cakeuserdata"));
      let paymentMethods = paymentMethodTemp.paymentMethods;
      paymentMethods[0] = "Outros"; //Pagamentos não definidos
      var widgetPayment = [];

      Object.values(paymentMethods).forEach(element => {
        let widgetObject = { paymentMethods: element };
        widgetPayment.push(widgetObject);
      });
      //console.log("widgetPayment", widgetPayment);
      const valorAtual = row.paymentMethod;
      var paymentValue = widgetPayment.map((elemento, indice) => {
        let item = {};
        // console.log("item", item);

        item.posicao = indice;
        if (item.posicao == valorAtual) {
          item.nome = elemento.paymentMethods;
          //console.log("passouu");
          indice + 1;
          return item.nome;
        }

        //console.log("item nome", item.nome , item.posicao);
      });
     

      return paymentValue;
      /*
       */
    },

    getSummaries(param) {
      //console.log("param", param);
      const { columns, data } = param;
      const sums = [];
      //console.log("columns", columns);
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        if (index == columns.length - 1) {
          sums[index] = "100%";
          return;
        }
        //console.log("column", column);
        //console.log("data", data);
        const values = data.map(item => Number(item.value));
        console.log("values", values);
        if (!values.every(value => isNaN(value))) {
          let sum = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sum.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
          });
          this.sumsTotalRows = sum;
        } else {
          sums[index] = "N/A";
        }
      });
      //console.log("sums", sums);
      return sums;
    },
    paginationChanged(page) {
      this.pagination.currentPage = page;
    },

    handleLike(index, row) {
      swal({
        title: `You liked ${row.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "btn btn-success btn-fill"
      });
    },
    handleEdit(index, row) {
      swal({
        title: `You want to edit ${row.name}`,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-info btn-fill"
      });
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.name}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    handleExpandChange(row, expandedRows) {
      const id = row.id;
      const lastId = this.expandRowKeys[0];
      // disable mutiple row expanded
      this.expandRowKeys = id === lastId ? [] : [id];
    }
  }
};
</script>
<style scoped>
@import url("//unpkg.com/element-ui@2.4.11/lib/theme-chalk/index.css");
.card .table td,
.card .table th,
.card .el-table td,
.card .el-table th {
  padding-left: 1rem;
  padding-right: 1rem;
}

.expand-content {
  margin-left: 40px;
}
</style>
